// type

import { AES, enc } from "crypto-js";
import * as url from "../store/constant/Endpoints";

import icons from "helper/iconsHelper";

import {
  can_add_clients,
  per_payment_view,
  per_prescription_view,
} from "../helper/permissionsCheck";

// let permissionUser = localStorage.getItem("LoginData");
// let permissions = JSON.parse(permissionUser)?.permissions;

let permissionUser = localStorage.getItem("data");

let decryptedData = null;
if (permissionUser) {
  try {
    // Code that may throw an exception
    decryptedData = AES.decrypt(permissionUser, url.encryptionSecret).toString(
      enc.Utf8
    );
    // ...
  } catch (error) {
    console.log(error, "er");
  }
}

const permissions = decryptedData
  ? JSON.parse(decryptedData)?.permissions
  : null;

const allowedPermissions =
  permissions && permissions.length !== 0
    ? permissions.map((permission) => permission?.permission)
    : [];

const permissionsAccessFunction = (brand) => {
  return (
    allowedPermissions &&
    allowedPermissions.length !== 0 &&
    allowedPermissions.some((permission) => permission.includes(brand))
  );
};
// ==============================|| MENU ITEMS - roles ||============================== //

// const flat = permissionsAccessFunction('company') ? {
const prescriptions = per_prescription_view
  ? {
      id: "Prescription",
      title: "Prescription",
      icon: icons.prescriptions,
      type: "group",
      children: [
        per_prescription_view
          ? {
              id: "all-prescription",
              title: "Prescriptions",
              type: "item",
              url: "/prescription/all-prescriptions",
              icon: icons.prescriptions,
              breadcrumbs: true,
            }
          : null,
      ].filter(Boolean),
    }
  : null;
export default prescriptions;
